<template>
  <div class="bg auth-screen">
    <div class="container pt-80">
      <div v-if="keys && Object.keys(keys).length > 0">
        <div class="card" v-if="!showSuccessMsg">
          <div v-if="keys && Object.keys(keys).length > 0" class="card-body">
            <h2 class="card-title">{{ keys.RESET_NEW_PASSWORD }}</h2>
            <form v-bind:class="$route.params.lang === 'RTL' ? 'lang-dir' : ''" dir="auto">
              <div class="form-group">
                <input type="password" class="form-control form-control-lg placeHolderCSS" @input="validPassword(user.password), validateConfirmPassword()" v-model="user.password" :placeholder="[[keys.RESET_PLACEHOLDER_PASSWORD]]" required />
              </div>
              <div class="form-group">
                <input type="password" class="form-control form-control-lg placeHolderCSS" @input="validateConfirmPassword()" v-model="user.confirmPassword" :placeholder="[[keys.RESET_PLACEHOLDER_CONFIRM_PWD]]" required />
                <p class="text-danger" v-if="passwordNotMatched">
                  {{ keys.RESET_PASSWORD_NOT_MATCH }}
                </p>
                <div class="regex-req">
                  <div class="req-title">{{ keys.RESET_PASSWORD_REQUIRE }}</div>
                  <ul class="validation-list">
                    <li>
                      <span
                        v-if="passwordReq.showErrors"
                        :class="{
                          success: passwordReq.min8char,
                          error: !passwordReq.min8char
                        }"
                        aria-hidden="true"
                      ></span>
                      <span v-else class="initial-state" aria-hidden="true"></span>
                      {{ keys.RESET_MIN_CHAR }}
                    </li>
                    <li>
                      <span
                        v-if="passwordReq.showErrors"
                        :class="{
                          success: passwordReq.anyLetter,
                          error: !passwordReq.anyLetter
                        }"
                        aria-hidden="true"
                      ></span>
                      <span v-else class="initial-state" aria-hidden="true"></span>
                      {{ keys.pass_requirment_min_one_letter }}
                    </li>
                    <li>
                      <span
                        v-if="passwordReq.showErrors"
                        :class="{
                          success: passwordReq.number,
                          error: !passwordReq.number
                        }"
                        aria-hidden="true"
                      ></span>
                      <span v-else class="initial-state" aria-hidden="true"></span>
                      {{ keys.RESET_NUMBER }}
                    </li>
                    <li>
                      <span
                        v-if="passwordReq.showErrors"
                        :class="{
                          success: passwordReq.specialChar,
                          error: !passwordReq.specialChar
                        }"
                        aria-hidden="true"
                      ></span>
                      <span v-else class="initial-state" aria-hidden="true"></span>
                      {{ keys.RESET_SYMBOL }}
                    </li>
                  </ul>
                </div>
                <p class="text-danger mt-16" v-if="errorMsg">{{ this.errorMsg }} sasas as as as asa sas asas asas asas</p>
              </div>
            </form>
            <div class="form-group mb-0">
              <button type="button" class="btn btn-primary btn-block" :disabled="disableSubmitBtn" v-on:click.prevent="changePassword">
                {{ keys.RESET_CONTINUE }}
              </button>
            </div>
          </div>
        </div>
        <div v-else class="text-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <h4>{{ keys.RESET_PASSWORD_SUCCESSFUL }}</h4>
        </div>
      </div>
    </div>
    <p class="special-error" v-if="specialError">{{ specialError }}</p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ParticiapntResetPassword",
  data() {
    return {
      showSuccessMsg: false,
      errorMsg: false,
      user: {
        password: "",
        confirmPassword: ""
      },
      keys: null,
      languageId: this.$route.params.languageId ? this.$route.params.languageId : null,
      specialError: null,
      passwordReq: {
        min8char: false,
        anyLetter: false,
        number: false,
        specialChar: false,
        showErrors: false,
        passwordMatched: false
      },
      passwordNotMatched: false,
      disableSubmitBtn: true
    };
  },
  computed: {
    ...mapGetters(["token"])
  },
  mounted() {
    if (this.token) {
      this.userLogout();
    }
    this.getKeys();
  },
  methods: {
    ...mapActions(["userLogout"]),
    changePassword() {
      this.$api
        .participantForgotPasswordFact({
          token: this.$route.params.token,
          newPassword: this.user.password
        })
        .then(
          () => {
            this.correctOTP = true;
            this.showSuccessMsg = true;
          },
          error => {
            this.errorMsg = true;
            this.errorMsg = error.body && error.body.message ? error.body.message : this.keys.RESET_PROCESS_ERROR;
          }
        );
    },
    validateConfirmPassword() {
      this.disableSubmitBtn = true;
      this.passwordNotMatched = false;
      this.passwordReq.passwordMatched = false;
      if (this.user.password === this.user.confirmPassword && this.passwordReq.min8char && this.passwordReq.anyLetter && this.passwordReq.number && this.passwordReq.specialChar) {
        this.passwordNotMatched = false;
        this.disableSubmitBtn = false;
        this.passwordReq.passwordMatched = true;
      } else if (this.user.confirmPassword === "") {
        this.passwordNotMatched = false;
      } else if (this.user.password === this.user.confirmPassword) {
        this.passwordNotMatched = false;
        this.passwordReq.passwordMatched = true;
      } else {
        this.passwordNotMatched = true;
      }
    },
    validPassword(password) {
      this.disableSubmitBtn = true;
      this.passwordReq.showErrors = true;
      const numberPattern = new RegExp("^(?=.*[0-9]).+$");
      const specialPattern = new RegExp("^(?=.*[!\"#@$%&'()*+,-./:;<=>?[\\]^_{|}~]).+$");
      const letterPattern = new RegExp("^(?=.*[a-zA-Z]).+$");
      // empty password check
      if (password === "") {
        this.passwordReq.showErrors = false;
      } else if (password.length >= 8) {
        this.passwordReq.min8char = true;
      } else if (password.length < 8) {
        this.passwordReq.min8char = false;
      }

      // any letter pattern check
      if (letterPattern.test(password)) {
        this.passwordReq.anyLetter = true;
      } else {
        this.passwordReq.anyLetter = false;
      }

      //Atleast 1 number
      if (numberPattern.test(password)) {
        this.passwordReq.number = true;
      } else {
        this.passwordReq.number = false;
      }

      //Atleast 1 special char
      if (specialPattern.test(password)) {
        this.passwordReq.specialChar = true;
      } else {
        this.passwordReq.specialChar = false;
      }
    },
    getKeys() {
      this.$api.resetPasswordKey(this.languageId, this.$route.params.token).then(
        response => {
          this.keys = response && response.body;
        },
        error => {
          this.specialError = error.body && error.body.message ? error.body.message : error.body && error.body.message_key ? error.body.message_key : "Something while wrong while loading the page";
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.lang-dir {
  text-align-last: right;
}
.special-error {
  text-align: center;
  font-size: 21px;
  color: #fff;
}
h4 {
  color: #fff;
}
@media (min-width: 600px) {
  .auth-screen .card {
    max-width: 505px !important;
  }
}
@media (max-width: 600px) {
  .placeHolderCSS {
    padding-bottom: 1.4rem !important;
    padding-top: 1.1rem !important;
  }
}
</style>
<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
